export default __webpack_public_path__ + "static/media/65.96b02c21.jpeg";